<div class="respondent-page">
  <div class="respondent-shell">
    <!-- Header: logo and progress -->
    <header class="card respondent-header">
      <img
        src="assets/images/KubaLogo.png"
        alt="Kuba"
        class="respondent-header__logo"
      />
      <div class="respondent-header__progress" *ngIf="survey">
        <p-progressBar
          [value]="progressPercent"
          [showValue]="false"
        ></p-progressBar>
        <span class="respondent-header__progress-text">
          {{
            "WORK_ENVIRONMENT_SURVEY.RESPONDENT.PROGRESS_COMPLETED"
              | translate: { percent: progressPercent }
          }}
        </span>
      </div>
    </header>

    <div class="card respondent-card" *ngIf="isLoading">
      <div class="loading-state">
        <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
        <span translate>WORK_ENVIRONMENT_SURVEY.LOADING</span>
      </div>
    </div>

    <!-- Bad or expired link -->
    <div class="card respondent-card" *ngIf="state === 'error'">
      <h1 translate>WORK_ENVIRONMENT_SURVEY.RESPONDENT.LINK_INVALID_TITLE</h1>
      <p translate>WORK_ENVIRONMENT_SURVEY.RESPONDENT.LINK_INVALID_BODY</p>
    </div>

    <!-- Welcome -->
    <div
      class="card respondent-card"
      *ngIf="!isLoading && state === 'not-started' && survey"
    >
      <h1 translate>WORK_ENVIRONMENT_SURVEY.RESPONDENT.WELCOME_TITLE</h1>
      <p class="respondent-card__lead">{{ survey.Title }}</p>
      <p translate>WORK_ENVIRONMENT_SURVEY.RESPONDENT.WELCOME_BODY</p>
      <div class="respondent-card__actions respondent-card__actions--center">
        <button type="button" class="btn btn-success" (click)="start()">
          <span translate>WORK_ENVIRONMENT_SURVEY.RESPONDENT.START</span>
        </button>
      </div>
    </div>

    <!-- One category of questions -->
    <div
      class="card respondent-card"
      *ngIf="state === 'in-progress' && currentCategory as category"
    >
      <span class="respondent-card__step">
        {{
          "WORK_ENVIRONMENT_SURVEY.RESPONDENT.CATEGORY_PROGRESS"
            | translate: { current: categoryIndex + 1, total: categoryCount }
        }}
      </span>
      <h1>{{ category.Title }}</h1>
      <p>{{ category.Description }}</p>

      <div class="question" *ngFor="let question of category.Questions">
        <div class="question__text">{{ question.Text }}</div>
        <div class="question__options">
          <label
            class="question__option"
            *ngFor="let value of answerValues; let optionIndex = index"
          >
            <input
              type="radio"
              [name]="'question-' + question.Id"
              [value]="value"
              [checked]="question.Response === value"
              (change)="setAnswer(question.Id, value)"
            />
            <span>{{ category.Options[optionIndex] }}</span>
          </label>
        </div>
      </div>

      <div class="respondent-card__actions">
        <button
          type="button"
          class="btn btn-outline-secondary"
          [disabled]="categoryIndex === 0 || isSaving"
          (click)="back()"
        >
          <span translate>BACK</span>
        </button>

        <button
          type="button"
          class="btn btn-success"
          *ngIf="!isLastCategory"
          [disabled]="!isCurrentCategoryComplete || isSaving"
          (click)="next()"
        >
          <i
            *ngIf="isSaving"
            class="fa fa-spinner fa-spin m-r-1"
            aria-hidden="true"
          ></i>
          <span translate>NEXT</span>
        </button>

        <button
          type="button"
          class="btn btn-success"
          *ngIf="isLastCategory"
          [disabled]="!isCurrentCategoryComplete || isSaving"
          (click)="finish()"
        >
          <i
            *ngIf="isSaving"
            class="fa fa-spinner fa-spin m-r-1"
            aria-hidden="true"
          ></i>
          <span translate>WORK_ENVIRONMENT_SURVEY.RESPONDENT.FINISH</span>
        </button>
      </div>
    </div>

    <!-- Thank you -->
    <div class="card respondent-card" *ngIf="state === 'completed' && survey">
      <h1 translate>WORK_ENVIRONMENT_SURVEY.RESPONDENT.THANK_YOU_TITLE</h1>
      <p translate>WORK_ENVIRONMENT_SURVEY.RESPONDENT.THANK_YOU_BODY</p>
      <p class="respondent-card__signature">
        <strong>{{ survey.BusinessName }}</strong>
      </p>
      <div class="respondent-card__actions">
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="backToSurvey()"
        >
          <span translate>BACK</span>
        </button>
      </div>
    </div>
  </div>
</div>
